<template>
  <div
    class="vqb-group card"
    :class="'depth-' + depth.toString()"
  >
    <div class="vqb-group-heading card-header">
      <div class="match-type-container form-inline">
        {{ query.logicalOperator }}
      </div>
    </div>

    <div class="vqb-group-body card-body">
      <expression-children v-bind="$props" />
    </div>
  </div>
</template>

<script>
import ExpressionChildren from '@/components/notifications/settings/ExpressionChildren';

export default {
  name: 'ExpressionGroup',
  props: ['query', 'depth', 'index', 'vars', 'members'],
  components: {
    ExpressionChildren,
  },
};
</script>

<style>
.vue-query-builder .vqb-group .rule-actions {
  margin-bottom: 20px;
}

.vue-query-builder .vqb-rule {
  margin-top: 15px;
  margin-bottom: 15px;
  background-color: #f5f5f5;
  border-color: #ddd;
  padding: 15px;
}

.vue-query-builder .vqb-group.depth-1 .vqb-rule,
.vue-query-builder .vqb-group.depth-2 {
  border-left: 2px solid #8bc34a;
}

.vue-query-builder .vqb-group.depth-2 .vqb-rule,
.vue-query-builder .vqb-group.depth-3 {
  border-left: 2px solid #00bcd4;
}

.vue-query-builder .vqb-group.depth-3 .vqb-rule,
.vue-query-builder .vqb-group.depth-4 {
  border-left: 2px solid #ff5722;
}

.vue-query-builder .close {
  opacity: 1;
  color: rgb(150, 150, 150);
}

@media (min-width: 768px) {
  .vue-query-builder .vqb-rule.form-inline .form-group {
    display: block;
  }
}
</style>
